module.exports = __webpack_public_path__ + "static/media/case-details-de.3552e302.png";